const ToggleBarMenuIcon = ({ size = 24, color = 'currentColor', ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='text-[#6F767E] hover:text-black'
        {...props}
    >
        <path
            d='M3 12H13'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M3 18H21'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M3 6H21'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default ToggleBarMenuIcon;
